import { ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { FloatingAiButton } from '@/features/ai/FloatingAiButton';

interface LayoutProps {
  children: ReactNode;
  title?: string;
  showNav?: boolean;
}

export function Layout({ children, showNav = true }: LayoutProps) {
  return (
    <>
      <main className="app-content">
        {children}
      </main>
      {showNav && <BottomNav />}
      {showNav && <FloatingAiButton />}
    </>
  );
}
